/**
 * @enum UiTheme
 * @description All supported themes will be defined here
 */
enum UiTheme {
  ORANGE = "ORANGE",
  GREEN = "GREEN",
  PURPLE = "PURPLE",
  BLACK = "BLACK",
  BLUE = "BLUE",
  INDIGO = "INDIGO",
  MIDNIGHT_BLUE = "MIDNIGHT_BLUE"
}

export default UiTheme;
